<script setup>
import { computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  orientation: {
    type: String,
    required: true,
    validator: value => ['left', 'right', 'center'].includes(value),
  },
  showReply: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['reply']);

// Para mensagens do cliente (left), botão fica à direita
// Para mensagens do agente (right), botão fica à esquerda
const positionClass = computed(() => {
  if (props.orientation === 'left') {
    return 'right-0 translate-x-full';
  }
  return 'left-0 -translate-x-full';
});
</script>

<template>
  <div
    v-if="orientation !== 'center'"
    class="message-actions absolute top-1/2 -translate-y-1/2 flex items-center gap-1 opacity-0 group-hover/message:opacity-100 transition-opacity duration-150 z-10"
    :class="positionClass"
  >
    <Button
      v-if="showReply"
      v-tooltip="$t('CONVERSATION.CONTEXT_MENU.REPLY_TO')"
      ghost
      xs
      slate
      icon="i-lucide-reply"
      class="bg-n-background/80 backdrop-blur-sm shadow-sm border border-n-weak hover:bg-n-alpha-2 rounded-full"
      @click.stop="emit('reply')"
    />
  </div>
</template>

<style lang="scss" scoped>
.message-actions {
  @apply px-2;
}
</style>
